import BidResume from '@/brain/report/bid-resume'
import CountBid from '@/brain/report/count-bid'
import InProgress from '@/brain/report/in-progress'
import CountValues from '@/brain/report/count-values'

const state = {}

const getters = {}

const mutations = {}

const actions = {
  BID_RESUME: BidResume,
  COUNT_BID: CountBid,
  IN_PROGRESS: InProgress,
  COUNT_VALUES: CountValues
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/view/dashboard/state/index.js